import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { generateRandomPosition, formatTime } from '../../utils/gameUtils';

const GameTwo = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [gameActive, setGameActive] = useState(false);
  const [highScore, setHighScore] = useState(0);
  const [misses, setMisses] = useState(0);

  useEffect(() => {
    let timer;
    if (gameActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      endGame();
    }
    return () => clearInterval(timer);
  }, [gameActive, timeLeft]);

  const startGame = () => {
    setGameActive(true);
    setScore(0);
    setMisses(0);
    setTimeLeft(30);
    moveTarget();
  };

  const endGame = () => {
    setGameActive(false);
    const finalScore = score;
    if (finalScore > highScore) {
      setHighScore(finalScore);
    }
  };

  const moveTarget = () => {
    const gameArea = document.querySelector('.game-area');
    if (gameArea) {
      const maxWidth = gameArea.clientWidth - 50;
      const maxHeight = gameArea.clientHeight - 50;
      setPosition(generateRandomPosition(maxWidth, maxHeight));
    }
  };

  const handleTargetClick = (e) => {
    e.stopPropagation();
    if (gameActive) {
      setScore(prev => prev + 1);
      moveTarget();
    }
  };

  const handleMiss = () => {
    if (gameActive) {
      setMisses(prev => prev + 1);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="game-container"
    >
      <h2 className="text-2xl font-bold mb-4 text-center">Target Practice</h2>

      <div className="mb-4 text-center">
        <p className="text-sm text-gray-600">High Score: {highScore}</p>
      </div>

      {!gameActive ? (
        <div className="space-y-4">
          <p className="text-center text-gray-700">
            Click the moving target! Be quick and accurate!
          </p>
          <button
            onClick={startGame}
            className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 transition"
          >
            Start Game
          </button>
        </div>
      ) : (
        <div
          className="game-area relative h-64 bg-white border-2 border-purple-300 rounded overflow-hidden"
          onClick={handleMiss}
        >
          <div className="absolute top-0 left-0 right-0 bg-white/80 p-2 flex justify-between text-sm">
            <span>Score: {score}</span>
            <span>Misses: {misses}</span>
            <span>Time: {formatTime(timeLeft)}</span>
          </div>

          <motion.div
            className="absolute cursor-pointer"
            style={{ left: position.x, top: position.y }}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            onClick={handleTargetClick}
          >
            <span className="text-4xl select-none">🎯</span>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default GameTwo;
